"use strict";

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".logo-strip").forEach(function (logoStrip) {
    var logos = logoStrip.querySelector(".logo-wrapper .logo-inner > div");
    if (!logos) return;

    for (var i = 0; i < 2; i++) {
      var clone = logos.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      logos.after(clone);
    }
  });

  var header = document.querySelector("#shopify-section-header > header");
  var firstSection = document.querySelector(
    "#main-content > .shopify-section:first-child"
  );

  if (!header || !firstSection) return;

  function adjustForHeaderHeight() {
    var headerHeight = header.clientHeight;
    firstSection.style.setProperty(
      "--MUSE-first-section-header-overlap",
      String(Math.ceil(headerHeight)) + "px"
    );
  }

  adjustForHeaderHeight();

  var debounce = null;
  window.addEventListener("resize", function () {
    clearTimeout(debounce);
    debounce = setTimeout(adjustForHeaderHeight, 250);
  });
});

if (typeof jQuery !== "undefined") {
  jQuery(document).ready(function ($) {
    if ($(".hero-section").length > 0) {
      function scrollDownArrow() {
        $(".hero-section .scroldown .btn-down img").css({
          animation: "wheel 2s ease-in-out",
        });
        setTimeout(function () {
          $(".hero-section .scroldown .btn-down img").css({ animation: "none" });
        }, 2000);
      }

      function arrowAnimHandler(e) {
        e.target.pause();

        setTimeout(function () {
          e.target.play();
          scrollDownArrow();
        }, 2000);
      }

      $(document).on("ended", "#museBgVideo, #museBgVideoMobile", arrowAnimHandler);
    }
  });
}
